module.exports = __webpack_public_path__ + "static/media/badge-stats-chart.667caa68.jpg";